import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "home" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, "Event: " + _toDisplayString(_ctx.eventId), 1),
    _hoisted_1
  ], 64))
}